module.exports = __webpack_public_path__ + "static/img/experienceGold.f4cbcc4e.png";